import { emailLogGQLFields } from '../email/index.js';
import { memberGQLFields } from './member.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_MEMBER_INVITATION_FIELDS = {};
const ALL_MEMBER_INVITATION_FIELDS = {
    invitee: 'basic',
    inviter: 'basic',
    role: 'basic',
    emailLog: 'basic',
};
export function memberInvitationGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_MEMBER_INVITATION_FIELDS;
    if (fields === 'all')
        fields = ALL_MEMBER_INVITATION_FIELDS;
    return `
    createdAt
    expiresAt
    id
    invitationMessage
    inviteeId
    inviteeEmail
    inviteeName
    inviterId
    joinedAt
    status
    ${fields.invitee
        ? `
      invitee {
        ${memberGQLFields(fields.invitee)}
      }
    `
        : ``}
    ${fields.inviter
        ? `
      inviter {
        ${memberGQLFields(fields.inviter)}
      }
    `
        : ``}
    ${fields.role
        ? `
      role {
        ${roleGQLFields(fields.role)}
      }
    `
        : ``}
    ${fields.emailLog
        ? `
      emailLog {
        ${emailLogGQLFields()} 
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=memberInvitation.fields.js.map